import React, { Component } from "react";

import "./WebViewExtension.css";

export const WEB_VIEW_EXT_ID = "WEB_VIEW";

export default class WebViewExtension extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // bottomMargin: 0,
      popUpHeight: 0,
      title: props.webview.title,
      url: props.webview.url,
      height: props.webview.height,
      hideHeader: props.webview.largeWindowHideHeader,
    };

   
    // Resize box to sit above input
    this.findInputTimerId = setInterval(() => {
      let chatbox = document.getElementById("chat_box");

      if (!chatbox) {
        return;
      }

      let inputs = chatbox.querySelectorAll("input");
      let inputRegion = chatbox.querySelectorAll("[role='form']");

      if (inputs.length < 1 || inputRegion.length < 1) {
        return;
      }

      let popUp = document.getElementsByClassName("chat_popup booking_popup");

      if (popUp.length) {
        this.setState({
          popUpHeight: popUp[0].clientHeight,
        });
      }

      // this.setState({
      //     bottomMargin: inputRegion[0].clientHeight
      // });

      clearInterval(this.findInputTimerId);
    }, 50);

    this.close = this.close.bind(this);
  }

  componentDidUpdate(oldProps) {
    if (!this.props.webview) {
      return;
    }

    if (
      !oldProps.webview ||
      oldProps.webview.title !== this.props.webview.title ||
      oldProps.webview.url !== this.props.webview.url ||
      oldProps.webview.height !== this.props.webview.height ||
      oldProps.webview.largeWindowHideHeader !==
        this.props.webview.largeWindowHideHeader
    ) {
      this.setState({
        title: this.props.webview.title,
        url: this.props.webview.url,
        height: this.props.webview.height,
        hideHeader: this.props.webview.largeWindowHideHeader,
      });
    }
  }

  close() {
    this.setState({
      closing: true,
    });
    // Allow animation to play
    setTimeout(() => {
      this.setState({
        closing: false,
      });

      this.props.api.setExtension(WEB_VIEW_EXT_ID, undefined);
    }, 800);
  }

  render() {
    const color = this.props.styling;
    let containerStyling = {
      // bottom: this.state.bottomMargin,
      // height: 'calc(' + this.state.height + '% - ' + (this.state.bottomMargin + this.state.popUpHeight) + 'px)',
      height: this.props.messenger === true ?
        this.state.hideHeader !== undefined && this.state.hideHeader === true ? "calc(100vh - 1px)" : "calc(100vh - 55px)" : "calc(" + this.state.height + "% - " + 0 + "px)",
      animationName: this.state.closing ? "slide-down" : "slide-up",
      top: this.props.messenger === true ?
        this.state.hideHeader !== undefined && this.state.hideHeader === true ? "0px" : "16px" : ""
    };

    return (
      <div className="web-view-container" style={containerStyling}>
        {this.state.hideHeader !== undefined &&
        this.state.hideHeader === true ? (
          <div className="web-view-close-chatbox" onClick={this.close}>
            <svg
              style={{
                fill:
                  this.state.url.indexOf("/room?") > 0
                    ? "white"
                    : color.colours.headerText || "black",
              }}
              className="web-view-close-svg"
            >
              <use xlinkHref="/res/defs.svg#svg-icon-times"></use>
            </svg>
          </div>
        ) : (
          <div
            className="web-view-header"
            style={{
              backgroundColor: color.colours.header,
              color: color.colours.headerText,
            }}
          >
            <span className="truncate"> {this.state.title} </span>
            <div className="web-view-close" onClick={this.close}>
              {/* <svg
                style={{ fill: color.colours.headerText || "black" }}
                className="web-view-close-svg"
              >
                <use xlinkHref="/res/defs.svg#svg-icon-times"></use>
              </svg> */}
              <img src="/res/crosswebview.png" width="20" height="20"/>
            </div>
          </div>
        )}
        <div className="web-view-inner-container">
          <iframe
            src={this.state.url}
            title="Chat Web View"
            className="web-view-frame"
          />
        </div>
      </div>
    );
  }
}
